import { render, staticRenderFns } from "./ReplyBoxCampaign.vue?vue&type=template&id=657089b7&scoped=true&"
import script from "./ReplyBoxCampaign.vue?vue&type=script&lang=js&"
export * from "./ReplyBoxCampaign.vue?vue&type=script&lang=js&"
import style0 from "./ReplyBoxCampaign.vue?vue&type=style&index=0&id=657089b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657089b7",
  null
  
)

export default component.exports